import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef } from '../cd-popup';
import { DeviceOrientationServiceService } from 'src/app/core/services/device-orientation-service/device-orientation-service.service';
import { NgClass } from '@angular/common';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-will-be-lose-input',
  templateUrl: './will-be-lose-input.component.html',
  styleUrls: ['./will-be-lose-input.component.scss'],
  standalone: true,
  imports: [NgClass, CdsButtonModule, CdsLanguageModule],
})
export class WillBeLoseInputComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<WillBeLoseInputComponent>>(MatDialogRef);
  deviceOrientationService = inject(DeviceOrientationServiceService);

  ngOnInit(): void {}

  onCancel() {
    this.dialogRef.close({ agree: false });
  }

  onContinue() {
    this.dialogRef.close({ agree: true });
  }
}
